import { useEffect, useRef } from "react";
export var usePrevious = function (value) {
  var ref = useRef();
  return useEffect(function () {
    ref.current = value;
  }, [value]), ref.current;
};